import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import {
  Box,
  Card,
  CardHeader,
  CardBody,
  Heading,
  Text,
  Spinner,
  VStack,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from '@chakra-ui/react'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { ActivityTimeline } from '@/components/userActivity/ActivityTimeline'
import { LoginHistory } from '@/components/userActivity/LoginHistory'
import { ActiveSessions } from '@/components/userActivity/ActiveSessions'
import { ActivityStatistics } from '@/components/userActivity/ActivityStatistics'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function UserActivityPage() {
  const colors = useThemeColors()
  const navigate = useNavigate()
  const { userId: userIdParam } = useParams<{ userId: string }>()
  const userId = userIdParam ? Number(userIdParam) : undefined
  const [isValidating, setIsValidating] = useState(true)
  const [activeTab, setActiveTab] = useState(0)

  useEffect(() => {
    if (!userId || Number.isNaN(userId)) {
      navigate('/user-management/users', { replace: true })
    } else {
      setIsValidating(false)
    }
  }, [userId, navigate])

  if (isValidating || !userId) {
    return (
      <AdminLayout>
        <Box p={4}>
          <Card>
            <CardBody>
              <VStack spacing={4} py={8}>
                <Spinner size="xl" color="blue.500" />
                <Text>Loading...</Text>
              </VStack>
            </CardBody>
          </Card>
        </Box>
      </AdminLayout>
    )
  }

  return (
    <AdminLayout>
      <Box p={4} h="full" overflow="hidden" display="flex" flexDirection="column">
        <Card h="full" display="flex" flexDirection="column">
          <CardHeader flexShrink={0} pb={2}>
            <Heading size="md">User Activity</Heading>
            <Text fontSize="sm" color={colors.text} mt={1}>
              Monitor user login history, session activity, profile changes, and user-specific actions
            </Text>
          </CardHeader>
          <CardBody overflowY="auto" flex="1" minH={0} pt={0}>
            <Tabs index={activeTab} onChange={setActiveTab} colorScheme="blue">
              <TabList>
                <Tab>Timeline</Tab>
                <Tab>Login History</Tab>
                <Tab>Active Sessions</Tab>
                <Tab>Statistics</Tab>
              </TabList>

              <TabPanels>
                <TabPanel px={0} pt={4}>
                  <ActivityTimeline userId={userId} />
                </TabPanel>
                <TabPanel px={0} pt={4}>
                  <LoginHistory userId={userId} />
                </TabPanel>
                <TabPanel px={0} pt={4}>
                  <ActiveSessions userId={userId} />
                </TabPanel>
                <TabPanel px={0} pt={4}>
                  <ActivityStatistics userId={userId} />
                </TabPanel>
              </TabPanels>
            </Tabs>
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}


